function formatString(str) {
    return str.toLowerCase().replace(/\s+/g, '-');
}

function deformatString(str) {
    return str.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());;
}

const removeAfterUnderscore = (str) => str.split("_")[0];
  
const uploadToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "cv_upload");
  
    const res = await fetch("https://api.cloudinary.com/v1_1/dj4pocqis/upload", {
      method: "POST",
      body: data,
    });
  
    const result = await res.json();
    return result.secure_url;
  };

export {formatString, deformatString, removeAfterUnderscore, uploadToCloudinary};
  